import { render } from "./OhiloHeader.vue?vue&type=template&id=ffdd0d62"
import script from "./OhiloHeader.vue?vue&type=script&lang=js"
export * from "./OhiloHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__